import axios from 'axios';

const state = {
    authenticated: false,
    vehicleRegistered: false,
    errorMessage: '',
    statusMessage: '',
    errors: null,
    newlyRegistered: false,
    vehicleAdded: false,
    VehicleAddedMessage: '',
    showLoginModal:false,
    hasAccount: false,
    loginOnly:false,
    loginModal: {
        show:false,
        type:'',
    },
    priceAlertUnauthenticated:false,
};

const getters = {
    loginModal(state) {
        return state.loginModal;
    },
};

const actions = {
    async checkAuthenticated({ commit }) {
        try {
            const response = await axios.get('/api/auth-status')
            commit('setAuthenticated', response.data.authenticated)
        } catch (error) {
            console.error(error);
            reject(error);
        }
    },
    async registeredVehicle({ commit }, { vehicleReg }) {
        try {
            const response = await axios.get(`/api/check-vehicle/${vehicleReg}`)
            commit('setVehicleRegistered', response.data.registered)
        } catch (error) {
            console.error(error);
            reject(error);
        }
    },
    async login({ commit, dispatch, state }, { email, password }) {
        try {
            const response = await axios.post('/login', { email, password })
            commit('setShowLoginModal', {
                show:false,
                type:'',
            })
            commit('setErrors', null)
            dispatch('CustomerData/storeCustomerData', response.data.user, { root: true });
            dispatch('checkAuthenticated');
            const userName = response.data.user.firstName;
            if (this.hasModule('Layout')) {
                dispatch('Layout/saveVehicleAfterLogin', null, { root: true });
                dispatch('Layout/updateNavUserName', userName, { root: true });
                if(state.priceAlertUnauthenticated){
                    commit('Layout/setShowPriceAlertModal', true, { root: true });
                }
            }

            const myAccountSpan = document.getElementById('header-menu__my-account');
            if (myAccountSpan) {
                myAccountSpan.textContent = userName;
            }else{
                if (this.hasModule('Layout')) {
                    dispatch('Layout/updateNavUserName', userName, { root: true });
                }
            }
        } catch (error) {
            const errors = error.response.data.errors;
            console.error(error.response.data.errors)
            const flattenedErrors = [].concat(...Object.values(errors));
            console.error(flattenedErrors)
            commit('setErrors', flattenedErrors)
            throw error;
        }
    },
    async resetPassword({ commit }, { email, password }) {
        try {
            const response = await axios.post('/password/email', { email })
            commit('setErrors', null)
            commit('setStatusMessage', 'We have emailed your password reset link.');
        } catch (error) {
            const errors = error.response.data.errors;
            console.log(error.response.data.errors)
            const flattenedErrors = [].concat(...Object.values(errors));

            commit('setErrors', flattenedErrors)
            commit('setStatusMessage', null);
        }
    },
    createAccount({ commit, dispatch }, formData) {
        return new Promise((resolve, reject) => {
            axios.post('/api/register', formData)
            .then(response => {
                if (response.data.has_account == true && response.data.success == true) {
                    commit('setAuthenticated', true)
                    commit('setNewlyRegistered', true)
                    commit('setStatusMessage', 'Account created.');

                    if (this.hasModule('Layout')) {
                        const firstName = formData.get('first-name');
                        dispatch('Layout/updateNavUserName', firstName, { root: true });
                    }

                    if (response.data.vehicleAdded === true) {
                        commit('setVehicleAdded', true)
                        commit('setVehicleAddedMessage', 'This vehicle has been added to your account.');
                    } else {
                        commit('setVehicleAddedMessage', 'We were not able to add this vehicle to your account.');
                    }
                } else {
                    commit('setErrors', null);
                    commit('setStatusMessage', 'Account creation failed.');
                    resolve(response);
                }
                console.log('Success:', response.data);
                resolve(response);
            })
            .catch(error => {
                if (typeof error.response.data.errors != 'undefined') {
                    const errors = error.response.data.errors;
                    console.log(error.response.data.errors)
                    const flattenedErrors = [].concat(...Object.values(errors));
                    commit('setErrors', flattenedErrors)
                }
                commit('setStatusMessage', null);
                reject(error);
            });
        });
    },
};
const mutations = {
    setAuthenticated(state, authenticated) {
        state.authenticated = authenticated;
    },
    setVehicleRegistered(state, vehicleRegistered) {
        state.vehicleRegistered = vehicleRegistered;
    },
    setErrors(state, error) {
        state.errors = error
    },
    setVehicleAdded(state, vehicleAdded) {
        state.vehicleAdded = vehicleAdded;
    },
    setNewlyRegistered(state, newlyRegistered) {
        state.newlyRegistered = newlyRegistered;
    },
    setStatusMessage(state, message) {
        state.statusMessage = message;
    },
    setVehicleAdded(state, data) {
        state.vehicleAdded = data;
    },
    setVehicleAddedMessage(state, message) {
        state.vehicleAddedMessage = message;
    },
    setShowLoginModal(state, display) {
        // console.log(display);
        state.loginModal = display;
    },
    setHasAccount(state, hasAccount) {
        state.hasAccount = hasAccount;
    },
    setLoginOnly(state, loginOnly) {
        state.loginOnly = loginOnly;
    },
    setPriceAlertUnauthenticated(state, display){
        state.priceAlertUnauthenticated = display
    }
};
export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};




// WEBPACK FOOTER //
// ./resources/assets/js/core/modules/Auth/auth.js